import type { UserResponseAllOf } from './userResponseAllOf';
import type { UserResponseAllOfTwo } from './userResponseAllOfTwo';

/**
 * 사용자 응답 데이터
 */
export type UserResponse = UserResponseAllOf & UserResponseAllOfTwo;
